<script lang="js" setup>

</script>

<template>
  <div class="mt-[120px] max-md:mt-6">
    <h2 class="text-2xl font-medium texr-textPrimary max-md:text-lg">
      {{ $t('返佣规则') }}
    </h2>
    <div class="flex flex-col gap-2 pt-6 text-sm font-medium text-textPrimary">
      <p class="">
        {{ $t('一、好友使用您的邀请码注册后，您可以获得好友现货交易、合约交易的返佣奖励') }}
      </p>
      <p>{{ $t('1、现货交易返佣') }}</p>
      <p class="text-textSecondary">{{ $t('好友每进行一笔现货交易所产生的手续费，您可获得返佣。') }}</p>
      <p>{{ $t('2、合约返佣') }}</p>
      <p class="text-textSecondary">{{ $t('好友每进行一笔合约交易所产生的手续费，您可获得返佣。') }}</p>

      <p>{{ $t('二、普通用户返佣比例30%。因系统同步处理存在延迟，返佣数据存在约 1小时延迟，请以实际更新为准。') }}</p>

      <p>{{ $t('三、特别说明') }}</p>
      <p>{{ $t('1、2025年5月15日24:00（SGT）前在原Smart-App完成注册的用户。返佣邀请关系保留二级架构（直接邀请人、间接邀请人）。') }}</p>
      <p class="text-textSecondary">{{ $t('直接邀请人获得被邀请用户现货交易手续费的 30% 作为返佣；') }}</p>
      <p class="text-textSecondary">{{ $t('间接邀请人获得被邀请用户现货交易手续费的 20% 作为返佣。') }}</p>
      <p>{{ $t('2、仅显示2025年6月7日(SGT)后已完成交易的下级用户返佣记录,未产生交易的下级用户暂不显示。') }}</p>
    </div>
  </div>
</template>
